import * as React from 'react';
import { resolve } from 'inversify-react';
import CheckoutDataService from 'src/app/accounting/payment-gateway/checkout-service';

interface Sagepayprops extends GatewayProps {
}

interface SagepayState {
	processing: boolean;
	errors: string;
	sessionId: string;
}

export default class SagepayGateway extends React.Component<Sagepayprops, SagepayState>{


	@resolve
	checkoutService: CheckoutDataService;

	constructor(props) {
		super(props);

		this.state = {
			processing: true,
			errors: '',
			sessionId: ''
		}
	}

	render() {
		return (<div className="payment-container">

			<h2>SagePay</h2>

			{this.props.errors && this.props.errors.message && <h4 style={{ color: 'red' }}>{this.props.errors.message}</h4>}

			{this.state.errors && <h4 style={{ color: 'red' }}>{this.state.errors}</h4>}

			<form id="sagepay-form" onSubmit={this.handleSubmit}>
				<div id="sp-container">
				</div>

				<div id="submit-container">
					<div style={{ display: (this.state.processing && !this.props.errors) ? 'none' : 'initial' }}>{this.props.payComponent}</div>
				</div>

			</form>
		</div>);
	}

	private form: any;

	handleSubmit = (e) => {
		e.preventDefault();

	}

	initFrames = async () => {

		var sessionKey = await this.checkoutService.openSession<{
			expiry: Date,
			merchantSessionKey: string
		}>(this.props.gateway.paymentGatewayName);

		this.setState({ sessionId: sessionKey.merchantSessionKey });
		
		this.form = window.sagepayCheckout({
			merchantSessionKey: sessionKey.merchantSessionKey,
			containerSelector: '#sp-container',
			onTokenise: (result) => {
				this.setState({ errors: '' });
				

				if (result.success)
					this.props.onTokenReceive(result.cardIdentifier, this.props.gateway.paymentGatewayName, { sessionId: sessionKey.merchantSessionKey, expiry: sessionKey.expiry })
				else
					this.setState({ errors: result.error.errorMessage });
			}
		});


		this.form.form({ formSelector: '#sagepay-form' });

		this.setState({processing: false})
	}

	public componentDidMount() {
		const { gateway, onMount } = this.props;
		onMount(this.initFrames, [gateway.additionalInfo.sagePayScriptUrl]);
	}

	public componentWillUnmount() {
		if (this.form)
			this.form.destroy();
	}
}



// WEBPACK FOOTER //
// ./src/app/accounting/payment-gateway/parts/sagepay.tsx